// import Nat from "natjs"

export default {
  selectImage(allowFromGallery, showCamera, imageLimit) {
/*    return new Promise((resolve) => {
      if (allowFromGallery) {
        Nat.image.pick({
          limit: imageLimit,
          showCamera: showCamera
        }, (err, ret) => {
          if (err) {
            resolve(this.getResult(false, err))
          } else {
            resolve(this.getResult(true, ret.paths))
          }
        })
      } else {
        Nat.camera.captureImage({}, (err, ret) => {
          if (err) {
            resolve(this.getResult(false, err))
          } else {
            resolve(this.getResult(true, [ret.path]))
          }
        })
      }
    })*/
  },

  getResult(success, data) {
    return {
      success: success,
      data: data
    }
  }
};
